// extracted by mini-css-extract-plugin
module.exports = {"environment-banner":"styles_environment-banner__MIaL_","environmentBanner":"styles_environment-banner__MIaL_"};